<template>
  <div class="header">
    <!-- <header>1</header> -->
    <div class="line_wamp">
      <div>
      <!-- <img src="~@/assets/image/logo.png" alt="帘创优家" class="logn" /> -->
      <!-- <img src="~@/assets/image/2.png" alt="帘创优家" class="logn" /> -->
      <img class="line" src="~@/assets/image/线条1.png" alt="线条1" />
      </div>
    </div>
    <div class="title">
      <!-- <img src="~@/assets/image/标题.png" alt="线条1" /> -->
      <!-- <img src="~@/assets/image/1.png" alt="线条1" /> -->
      <img :src="imgLogo" alt="">
    </div>
    <div class="line_wamp">
      <img class="line" style="right:0" src="~@/assets/image/线条2.png" alt="线条2" />
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return{
      imgLogo:""
    }
  },
  created(){
    let timer =  setInterval(() => {
      if(this.$Logo.length > 0){
        clearInterval(timer)
        this.imgLogo = this.$Logo
      }
    } , 1000)
  }
};
</script>

<style lang="less">
.header {
  width: 100%;
  height: 10%;
  display: flex;
  justify-content: space-between;
  position: relative;
  left: 0;
  background-color: rgb(3,28,59);
  .line_wamp{
    width: 35%;
    height: 100%;
    padding: .625rem;
    box-sizing: border-box;
  }
  .title{
    padding: 1.875rem;
  }
  .logn{
    position: absolute;
  }
  .line{
    position: absolute;
    bottom: 0;
  }
}
</style>